import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCombined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_12182_100681)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.95 13C1.40833 13 0.947917 12.8277 0.56875 12.483C0.189583 12.1383 0 11.7197 0 11.2273C0 10.7348 0.189583 10.3163 0.56875 9.97159C0.947917 9.62689 1.40833 9.45455 1.95 9.45455C2.2425 9.45455 2.52417 9.5162 2.795 9.6395C3.06583 9.7628 3.29333 9.92767 3.4775 10.1341C4.11667 9.81894 4.63667 9.39545 5.0375 8.86364C5.43833 8.33182 5.6875 7.74091 5.785 7.09091H3.77C3.64 7.44545 3.40708 7.73106 3.07125 7.94773C2.73542 8.16439 2.36167 8.27273 1.95 8.27273C1.40833 8.27273 0.947917 8.10038 0.56875 7.75568C0.189583 7.41098 0 6.99242 0 6.5C0 6.00758 0.189583 5.58902 0.56875 5.24432C0.947917 4.89962 1.40833 4.72727 1.95 4.72727C2.36167 4.72727 2.73542 4.83561 3.07125 5.05227C3.40708 5.26894 3.64 5.55455 3.77 5.90909H5.785C5.6875 5.25909 5.43833 4.66818 5.0375 4.13636C4.63667 3.60455 4.11667 3.18106 3.4775 2.86591C3.29333 3.07273 3.06583 3.23779 2.795 3.36109C2.52417 3.48439 2.2425 3.54585 1.95 3.54545C1.40833 3.54545 0.947917 3.37311 0.56875 3.02841C0.189583 2.68371 0 2.26515 0 1.77273C0 1.2803 0.189583 0.861742 0.56875 0.517045C0.947917 0.172348 1.40833 0 1.95 0C2.49167 0 2.94667 0.167424 3.315 0.502273C3.68333 0.837121 3.87833 1.25076 3.9 1.74318C4.7775 2.15682 5.50333 2.72803 6.0775 3.45682C6.65167 4.18561 6.99833 5.00303 7.1175 5.90909H10.53L9.49 4.96364L10.4 4.13636L13 6.5L10.4 8.86364L9.49 8.03636L10.53 7.09091H7.1175C6.99833 7.99697 6.65708 8.81695 6.09375 9.55086C5.53042 10.2848 4.79917 10.8534 3.9 11.2568C3.87833 11.7492 3.68333 12.1629 3.315 12.4977C2.94667 12.8326 2.49167 13 1.95 13Z",
				fill: "#AA00FF"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_12182_100681",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 13,
				height: 13,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCombined);
export { ForwardRef as ReactComponent };
